module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"entering_year":"%{year}年入社","graduate":"卒業生","from":"%{school} 出身"}}}')
  delete Component.options._Ctor
}
